import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#0a0a14] text-gray-300">
      <nav className="border-b border-purple-900/30 bg-[#0d0d18]">
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/ac6eabdb4cc8c584e68459ed2e8db63e/795a02a9e33dcc555b6c719772e4793b.png"
              alt="Roblox Secrets"
              className="h-8 w-8 object-contain"
            />
            <span className="font-black text-yellow-400 text-base uppercase tracking-widest" style={{ textShadow: '0 0 10px rgba(250,204,21,0.4)' }}>
              Roblox Secrets
            </span>
          </Link>
          <Link to="/" className="text-sm text-gray-400 hover:text-yellow-400 transition-colors duration-200 flex items-center gap-1.5 cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </Link>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="mb-10">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-400 bg-yellow-400/10 px-3 py-1 rounded-full mb-4">Legal</span>
          <h1 className="text-3xl md:text-4xl font-black text-white mb-3">Terms of Service</h1>
          <p className="text-gray-500 text-sm">Last updated: April 6, 2026</p>
        </div>

        <p className="text-gray-300 leading-relaxed mb-8">
          By using this website, you agree to the following terms:
        </p>

        <div className="space-y-6">
          <Section title="Use of Content">
            <p className="text-gray-400 leading-relaxed">
              All content (ebooks, guides, videos) is for <strong className="text-white">personal use only</strong>.
              You may not copy, resell, or distribute it.
            </p>
          </Section>

          <Section title="Digital Products">
            <p className="text-gray-400 leading-relaxed">
              All purchases are for digital products delivered online.
            </p>
          </Section>

          <Section title="No Guarantees">
            <p className="text-gray-400 leading-relaxed">
              We provide tips, guides, and entertainment. We do not guarantee specific results in games.
            </p>
          </Section>

          <Section title="User Responsibility">
            <p className="text-gray-400 leading-relaxed">
              Users must use this site appropriately and respectfully.
            </p>
          </Section>

          <Section title="Children">
            <p className="text-gray-400 leading-relaxed">
              This website may be used by children under parental supervision.
            </p>
          </Section>

          <Section title="Changes">
            <p className="text-gray-400 leading-relaxed">
              We may update these terms at any time. Continued use of the site constitutes acceptance of the updated terms.
            </p>
          </Section>

          <Section title="Contact">
            <p className="text-gray-400 leading-relaxed">
              For any questions regarding these Terms of Service, contact us at:{' '}
              <a href="mailto:thekids@robloxsecrets.pro" className="text-yellow-400 hover:underline cursor-pointer">
                thekids@robloxsecrets.pro
              </a>
            </p>
          </Section>
        </div>

        <LegalNav current="terms" />
      </main>

      <LegalFooter />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="bg-[#0d0d18] border border-purple-900/30 rounded-lg p-6">
      <h2 className="text-white font-black text-lg mb-4 flex items-center gap-2">
        <span className="w-1 h-5 bg-yellow-400 rounded-full inline-block"></span>
        {title}
      </h2>
      {children}
    </div>
  );
}

function LegalNav({ current }: { current: string }) {
  const pages = [
    { label: 'Privacy Policy', href: '/privacy-policy', id: 'privacy' },
    { label: 'Terms of Service', href: '/terms', id: 'terms' },
    { label: 'Refund Policy', href: '/refund-policy', id: 'refund' },
    { label: 'Cookie Policy', href: '/cookie-policy', id: 'cookie' },
  ];
  return (
    <div className="mt-12 pt-8 border-t border-purple-900/30">
      <p className="text-gray-500 text-xs uppercase tracking-widest mb-4">Other Legal Pages</p>
      <div className="flex flex-wrap gap-3">
        {pages.filter(p => p.id !== current).map(p => (
          <Link
            key={p.id}
            to={p.href}
            className="text-sm text-gray-400 hover:text-yellow-400 border border-purple-900/40 hover:border-yellow-400/40 px-4 py-2 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {p.label}
          </Link>
        ))}
      </div>
    </div>
  );
}

function LegalFooter() {
  return (
    <footer className="border-t border-purple-900/30 bg-[#0d0d18] mt-8">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-gray-600 text-sm">&copy; {new Date().getFullYear()} Roblox Secrets. All rights reserved.</p>
        <p className="text-gray-700 text-xs text-center">Not affiliated with Roblox Corporation.</p>
      </div>
    </footer>
  );
}
